<template>
  <div v-if="supportOpen" class="support-box glass-support shadow-lg">
    <!-- HEADER -->
    <div
      class="support-header d-flex justify-content-between align-items-center"
    >
      <span class="fw-bold">
        {{ mode === "chat" ? "Live Chat" : "Submit Ticket" }}
      </span>

      <div>
        <button class="btn btn-sm btn-light me-2" @click="mode = 'chat'">
          Chat
        </button>
        <button class="btn btn-sm btn-light me-2" @click="mode = 'ticket'">
          Ticket
        </button>
        <span class="close-btn fs-5 pointer" @click="$emit('close')"
          >&times;</span
        >
      </div>
    </div>

    <!-- CHAT BODY -->
    <div v-if="mode === 'chat'" ref="chatBody" class="support-body">
      <div class="bot-msg">Hello &#128075; How can we assist you today?</div>

      <div v-for="(msg, i) in messages" :key="i">
        <div v-if="msg.type === 'user'" class="user-msg">
          {{ msg.text }}
        </div>

        <div v-else class="bot-msg">
          {{ msg.text }}
        </div>
      </div>

      <!-- TYPING INDICATOR -->
      <div v-if="isTyping" class="bot-msg typing">
        Typing<span class="dots">...</span>
      </div>
    </div>

    <!-- TICKET BODY -->
    <div v-if="mode === 'ticket'" class="support-body">
      <input v-model="user_name" class="form-control mb-3" placeholder="Full Name" />
      <input v-model="user_email" class="form-control mb-3" placeholder="Email or Phone" />
      <textarea v-model="message"
        class="form-control mb-3"
        rows="4"
        placeholder="Describe your question or issue..."
      ></textarea>
      <button class="btn btnprimary w-100 rounded-pill">Submit Ticket</button>
    </div>

    <!-- CHAT FOOTER -->
    <div v-if="mode === 'chat'" class="support-footer">
      <input
        v-model="message"
        class="form-control rounded-pill"
        placeholder="Type your message..."
        @keyup.enter="sendMessage"
      />

      <button
        class="btn btnprimary ms-2 px-3 rounded-pill"
        @click="sendMessage"
      >
        &#10148;
      </button>
    </div>
  </div>
</template>

<script>
import Config from '../Helpers/Config';

const API_BASE_URL = Config.API_BASE_URL
export default {
  props: {
    supportOpen: Boolean,
  },

  data() {
    return {
      mode: "chat",
      message: "",
      user_name:"",
      user_email:"",
      messages: [],
      isTyping: false,
    };
  },

  mounted() {
    this.scrollToBottom();
  },

  updated() {
    this.scrollToBottom();
  },

  watch: {
    supportOpen: {
      immediate: true,
      async handler(isOpen) {
        if (isOpen) {
          await this.loadUserDetails();
        }
      }
    }
  },

  methods: {
     async loadUserDetails() {
      try {
        const token = localStorage.getItem('auth_token');
        const storedUser = localStorage.getItem('user_data');

        if (!token || !storedUser) {
          console.log('Authentication data not found');
          return;
        }

        const userData = JSON.parse(storedUser);

        const response = await fetch(`${API_BASE_URL}/details`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `PRIMEPAY ${token}`,
            'user': userData.id
          },
          body: JSON.stringify({
            email: userData.email
          })
        });

        if (response.status === 401) {
          return;
        }

        const result = await response.json();

        if (!response.ok || result.success === '0') {
          throw new Error(
            result.errorDesc || 'Failed to fetch user details'
          );
        }

        console.log('User details response:', result);

        // Adjust this depending on your API response structure
        this.userDetails = result.errorDesc;

        console.log('User details:', this.userDetails);

        if (!this.userDetails) {
          return;
        }

        this.user_name = this.userDetails.firstname + ' ' + this.userDetails.lastname || '';
        this.user_email = this.userDetails.email || '';

        console.log('User name:', this.user_name);
        console.log('User email:', this.user_email);

      } catch (err) {
        console.error('Error fetching user details:', err);
        this.error = err.message;
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatBody = this.$refs.chatBody;

        if (chatBody) {
          chatBody.scrollTop = chatBody.scrollHeight;
        }
      });
    },

    async sendMessage() {
      if (!this.message.trim()) return;
      const userMsg = this.message;
      this.messages.push({
        type: "user",
        text: userMsg,
      });

      this.message = "";

      // show typing
      this.isTyping = true;

      // force UI update so typing shows immediately
      await this.$nextTick();

      // 3 second delay
      await new Promise((resolve) => setTimeout(resolve, 3000));

      try {
        const res = await fetch("https://services.libaaxc.com/alerts/chat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            message: userMsg,
          }),
        });

        const data = await res.json();

        this.messages.push({
          type: "bot",
          text: data.reply,
        });
      } catch (err) {
        console.error(err);

        this.messages.push({
          type: "bot",
          text: "Error connecting to server.",
        });
      } finally {
        this.isTyping = false;
      }
    },
  },
};
</script>

<style scoped>
.support-box {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 360px;
  border-radius: 20px;
  overflow: hidden;
  z-index: 1000;
}

.support-header {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  padding: 16px 20px;
}

.support-body {
  padding: 20px;
  height: 400px;
  overflow-y: auto;
  background: white;
  scroll-behavior: smooth;
}

.support-footer {
  display: flex;
  padding: 12px 20px;
  border-top: 1px solid #eee;
  background: #f8f9fa;
}

.support-footer input {
  border: none;
  background: white;
  border-radius: 50px;
  padding: 12px 16px;
}

.user-msg {
  background: var(--primary-color);
  color: white;
  padding: 8px 12px;
  border-radius: 18px;
  margin: 6px 0;
  text-align: right;
}

.bot-msg {
  background: #f1f1f1;
  color: #333;
  padding: 8px 12px;
  border-radius: 18px;
  margin: 6px 0;
}

.typing {
  font-style: italic;
  opacity: 0.8;
}

.dots::after {
  content: "";
  animation: dots 1.2s steps(3, end) infinite;
}

@keyframes dots {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
}

.rounded-pill {
  border-radius: 50rem !important;
}

.pointer {
  cursor: pointer;
}
</style>
